import React from 'react';
import {
  Box,
  Container,
  Heading,
  Text,
  VStack,
  HStack,
  Avatar,
} from '@chakra-ui/react';
import { motion } from 'framer-motion';

const MotionBox = motion(Box);

/**
 * Workshop Instructor Section
 * Displays instructor bio, photo, and credentials
 */
const WorkshopInstructor = ({ workshop }) => {
  if (!workshop?.instructor) return null;

  const { instructor } = workshop;

  return (
    <Box py={{ base: 16, md: 20 }} bg="white">
      <Container maxW="container.lg">
        <MotionBox
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <VStack align="center" spacing={12}>
            {/* Header */}
            <VStack align="center" spacing={3} textAlign="center">
              <Heading as="h2" size="xl" fontWeight="900" color="gray.900">
                Meet Your Instructor
              </Heading>
              <Text fontSize="lg" color="gray.600">
                Learn from industry experts with real-world experience
              </Text>
            </VStack>

            {/* Instructor Card */}
            <HStack
              spacing={{ base: 6, md: 12 }}
              align="center"
              w="full"
              flexDirection={{ base: 'column', md: 'row' }}
            >
              {/* Avatar */}
              {instructor.image && (
                <Avatar
                  name={instructor.name}
                  src={instructor.image}
                  size="2xl"
                  borderWidth="4px"
                  borderColor="purple.600"
                  flexShrink={0}
                />
              )}

              {/* Info */}
              <VStack align={{ base: 'center', md: 'start' }} spacing={4} flex={1}>
                <VStack align={{ base: 'center', md: 'start' }} spacing={1}>
                  <Heading as="h3" size="lg" fontWeight="bold" color="gray.900">
                    {instructor.name}
                  </Heading>
                  <Text color="purple.600" fontWeight="bold" fontSize="md">
                    {instructor.role}
                  </Text>
                </VStack>

                {instructor.bio && (
                  <Text
                    color="gray.600"
                    fontSize="md"
                    lineHeight="1.8"
                    textAlign={{ base: 'center', md: 'left' }}
                  >
                    {instructor.bio}
                  </Text>
                )}
              </VStack>
            </HStack>
          </VStack>
        </MotionBox>
      </Container>
    </Box>
  );
};

export default WorkshopInstructor;
